module.exports = __webpack_public_path__ + "img/20171103_122409-min.707e4d4b.jpg";